import type { FC } from "react"

import { useRecoilValue } from "recoil"

import { findProjectedNodeState, nodeIndex } from "../../../state/elements"
import { CoordinateTooltip } from "../../Overlays/CoordinateTooltip"

const NodeLabel: FC<{ id: string }> = ({ id }) => {
  const node = useRecoilValue(findProjectedNodeState(id))

  return <CoordinateTooltip where={node} says={id} />
}

const NodeLabels: FC = () => {
  const nodeIds = useRecoilValue(nodeIndex)

  return (
    <>
      {nodeIds.map((id) => (
        <NodeLabel id={id} key={`label_` + id} />
      ))}
    </>
  )
}

export default NodeLabels
